import { Navigate, Outlet, RouteObject, useLocation } from "react-router-dom";

const trimPathSegmentWhitespace = (pathname: string) =>
  pathname
    .split("/")
    .map((segment) => {
      if (!segment) return segment;

      try {
        const decodedSegment = decodeURIComponent(segment);
        const trimmedSegment = decodedSegment.trim();

        return trimmedSegment === decodedSegment
          ? segment
          : encodeURIComponent(trimmedSegment);
      } catch {
        return segment;
      }
    })
    .join("/");

const CanonicalPathGuard = () => {
  const location = useLocation();
  const pathname = trimPathSegmentWhitespace(location.pathname);

  if (pathname !== location.pathname) {
    return (
      <Navigate
        replace
        to={{ pathname, search: location.search, hash: location.hash }}
        state={location.state}
      />
    );
  }

  return <Outlet />;
};

export const withCanonicalPathGuard = (
  routes: RouteObject[],
): RouteObject[] => [
  {
    element: <CanonicalPathGuard />,
    children: routes,
  },
];
